<template>
    <div class="dropdown" ref="dropdown">
        <button 
            type="button"
            class="dropbtn"
            @click="toggleButton"
            aria-haspopup="true"
            aria-controls="map_type_menu"
        >
            {{ $t('Map type') }}
        </button>
        <div 
            class="dropdown-content" 
            id="map_type_menu"
            :class="{ 'show': isDropdownOpen }"
        >
            <button 
                v-for="item in mapTypeItems" 
                :key="item.type"
                :class="{ 'active': item.type === mapStore.map.getMapTypeId() }"
                type="button" 
                @click="selectMapType(item.type)"
            >
                {{ item.label }}
            </button>
        </div>
    </div>
</template>

<script>
import { useMaps } from '@/stores/maps'

export default {
    name: 'MapTypeControl',
    data() {
        return {
            isDropdownOpen: false,
            mapTypeItems: [
                { 
                    label: this.$t('Roadmap'),
                    type: 'roadmap'
                },
                { 
                    label: this.$t('Terrain'),
                    type: 'terrain'
                },
                { 
                    label: this.$t('Satellite'),
                    type: 'satellite'
                },
                { 
                    label: this.$t('Hybrid'),
                    type: 'hybrid'
                }
            ]
        }
    },
    setup() {
        const mapStore = useMaps()

        return {
            mapStore
        }
    },
    mounted() {
        // Add click event listener to close dropdown when clicking outside
        document.addEventListener('click', this.handleOutsideClick)
    },
    unmounted() {
        // Clean up event listeners when component is destroyed
        document.removeEventListener('click', this.handleOutsideClick)
    },
    watch: {
        '$i18n.locale': {
            handler() {
                const labels = ['Roadmap', 'Terrain', 'Satellite', 'Hybrid']
                
                this.mapTypeItems.forEach((item, index) => {
                    item.label = this.$t(labels[index])
                })
            },
            immediate: true
        }
    },
    methods: {
        toggleButton() {
            this.isDropdownOpen = !this.isDropdownOpen
        },
        selectMapType(type) {
            this.mapStore.map.setMapTypeId(type)
            this.mapStore.lastMapType = type
            this.isDropdownOpen = false

            if (type === 'satellite' && this.mapStore.map.getZoom() >= 20) {
                setTimeout(() => {
                    this.mapStore.map.setZoom(19)
                }, 100)
            }
        },
        handleOutsideClick(event) {
            if (this.isDropdownOpen && this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
                this.isDropdownOpen = false
            }
        }
    }
}
</script>